import PropertyItemTypeEnum from "../PropertyItemTypeEnum";
import PropertyTranslator from "../PropertyTranslator";

const booleanTranslator: PropertyTranslator<boolean> = {
    getItemType: () => PropertyItemTypeEnum.Boolean,

    getDisplayValue: (value) => value ? 'true' : 'false',
    setValue: (displayText) => ({ ok: true, value: displayText === 'true' }),

    isEqual: (a, b) => a === b,

    getListType: () => 'none',

    usesButton: () => false,

    refreshOnEdit: () => true,
};

export default booleanTranslator;
